import {
  GetAddressResponse,
  ServiceabilityAddressSuggestion,
} from "@/types/serviceability";
import { postJson } from "./shared";

export interface GetAddressParams {
  search: string;
  signal?: AbortSignal;
}

const normalizeSuggestion = (
  suggestion: GetAddressResponse["data"][number]
): ServiceabilityAddressSuggestion => ({
  label: suggestion.suggestion,
  fullAddress: suggestion.address.fullAddress ?? suggestion.suggestion,
  streetAddress1: suggestion.address.streetAddress1 ?? "",
  streetAddress2: suggestion.address.streetAddress2 ?? "",
  unitNumber: suggestion.address.unitNumber ?? "",
  unitType: suggestion.address.unitType ?? "",
  city: suggestion.address.city ?? "",
  state: suggestion.address.state ?? "",
  zipCode: suggestion.address.zipCode ?? "",
  zip4Code: suggestion.address.zip4Code ?? "",
  locationId: suggestion.address.locationId,
  elocId: suggestion.address.elocId,
  geofabricId: suggestion.address.geofabricId,
  addressType: suggestion.address.addressType ?? "",
  source: suggestion.address.source ?? "",
  searchType: suggestion.searchType ?? "",
});

export async function getAddress({
  search,
  signal,
}: GetAddressParams): Promise<ServiceabilityAddressSuggestion[]> {
  const trimmedSearch = search.trim();

  if (trimmedSearch.length < 3) {
    return [];
  }

  const response = await postJson<GetAddressResponse>({
    path: "/getaddress",
    body: { search: trimmedSearch },
    signal,
  });

  return Array.isArray(response.data)
    ? response.data.map(normalizeSuggestion)
    : [];
}
